// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__23cHZ","header":"PatientBlock_header__1VaM6","label":"PatientBlock_label__2dX_g","option":"PatientBlock_option__2vdgZ"};